import { request } from '../boot/request';

const getAddToCart = params => {
  params = params || {};
  return request({
    url: '/addToCart',
    method: 'POST',
    data: params,
  });
};
const getCartSimpleData = params => {
  params = params || {};
  return request({
    url: '/cartSummary',
    method: 'GET',
    params,
  });
};
const getCartDetailsData = params => {
  params = params || {};
  let cancelToken = null
  if (params.cancelToken) {
    cancelToken = params.cancelToken
    delete params.cancelToken
  }
  return request({
    url: '/cart',
    method: 'GET',
    cancelToken,
    timeout: 30000,
    params,
  });
};
const getCartItemData = params => {
  params = params || {};
  return request({
    url: '/cartItem',
    method: 'GET',
    params,
  });
};
const getUpdateCartData = params => {
  params = params || {};
  return request({
    url: '/updateCart',
    method: 'POST',
    data: params,
  });
};

const getEmptyCart = params => {
  params = params || {};
  return request({
    url: '/clearCart',
    method: 'GET',
    params,
  });
};

function clearInvalidCartItem() {
  return request({
    url: '/clearInvalidCartItem',
    method: 'POST',
  });
}
export {
  clearInvalidCartItem,
  getAddToCart,
  getCartSimpleData,
  getCartDetailsData,
  getCartItemData,
  getUpdateCartData,
  getEmptyCart,
};
